import React, { useContext, useEffect } from 'react'
import { Link as RouterLink, useNavigate, useLocation } from 'react-router-dom'
import {
   AppBar,
   Toolbar,
   Box,
   Button,
   Badge,
   IconButton,
   Hidden,
   TextField,
   InputAdornment,
   SvgIcon
} from '@material-ui/core'
import Logo from './Logo'
import ShoppingCartOutlinedIcon from '@material-ui/icons/ShoppingCartOutlined'
import ShoppingCartIcon from '@material-ui/icons/ShoppingCart'
import { ShoppingCartContext } from '../contexts/ShoppingCart'
import MenuIcon from '@material-ui/icons/Menu'
import { Search as SearchIcon } from 'react-feather'
import { getPublicAPI } from '../api'

const MainNavbar = ({ onMobileNavOpen }) => {
   const navigate = useNavigate()
   const location = useLocation()
   const { innerWidth: windowWidth } = window
   const {
      productsCount,
      searchC,
      setSearchC,
      setAllProducts,
      setSelectedDashSizesC,
      setSelectedHoseSizesC,
      setSelectedPressuresC,
      setSelectedSizesC,
      productRoute,
      setPrice,
      selectedHoseSizesC,
      selectedDashSizesC,
      selectedPressuresC,
      selectedSizesC,
      setOpenFittings,
      setOpenHoses
   } = useContext(ShoppingCartContext)
   try {
      var recentItem = JSON.parse(localStorage.getItem('recent'))
      if (recentItem && recentItem.length > 0)
         localStorage.setItem('recent', JSON.stringify(recentItem))
   } catch {
      var recentItems = []
      localStorage.setItem('recent', JSON.stringify(recentItems))
   }

   useEffect(() => {
      const getProducts = async () => {
         try {
            let productsData = await getPublicAPI('/get-products')
            if (productsData?.success) {
               setAllProducts(productsData?.data)
            }
         } catch (err) {
            console.log(err.message)
         }
      }
      getProducts()
   }, [navigate, productRoute])

   useEffect(() => {
      if (searchC.length === 0) {
         setSelectedDashSizesC([])
         setSelectedHoseSizesC([])
         setSelectedPressuresC([])
         setSelectedSizesC([])
         setPrice([])
      }
   }, [searchC])

   useEffect(() => {
      if (selectedHoseSizesC.length === 0 && selectedDashSizesC.length === 0) {
         setOpenFittings(false)
      }
      if (selectedPressuresC.length === 0 && selectedSizesC.length === 0) {
         setOpenHoses(false)
      }
   }, [selectedDashSizesC, selectedHoseSizesC, selectedPressuresC, selectedSizesC])

   return (
      <AppBar elevation={0}>
         <Toolbar sx={{ height: 64 }}>
            {!localStorage.auth_token && (
               <RouterLink to='/'>
                  <Logo />
               </RouterLink>
            )}
            {localStorage.auth_token && (
               <RouterLink to='/app/dashboard'>
                  <Logo />
               </RouterLink>
            )}
            {(location.pathname === '/fittings' ||
               location.pathname === '/hoses' ||
               location.pathname === '/product/' + productRoute ||
               location.pathname === '/view-cart' ||
               location.pathname === '/') && (
               <>
                  {windowWidth > 425 && (
                     <Box sx={{ marginLeft: 15, minWidth: '25vw' }}>
                        <TextField
                           id='search'
                           fullWidth
                           size='small'
                           sx={{
                              backgroundColor: 'white',
                              justifyContent: 'center',
                              alignItems: 'center',
                              height: 40
                           }}
                           InputProps={{
                              startAdornment: (
                                 <InputAdornment position='start'>
                                    <SvgIcon fontSize='small' color='action'>
                                       <SearchIcon />
                                    </SvgIcon>
                                 </InputAdornment>
                              )
                           }}
                           placeholder={
                              location.pathname === '/fittings'
                                 ? 'Search fittings'
                                 : location.pathname === '/hoses'
                                 ? 'Search hoses'
                                 : 'Search products'
                           }
                           value={searchC}
                           onChange={e => {
                              setSearchC(e.target.value)
                           }}
                           variant='outlined'
                        />
                     </Box>
                  )}
               </>
            )}
            {(location.pathname === '/fittings' ||
               location.pathname === '/hoses' ||
               location.pathname === '/product/' + productRoute ||
               location.pathname === '/view-cart' ||
               location.pathname === '/') && (
               <Box
                  sx={{
                     display: 'flex',
                     flexGrow: 1,
                     justifyContent: 'flex-end'
                  }}
               >
                  {(localStorage.user_type === 'customer' ||
                     (!localStorage.auth_token && localStorage.ip_address)) && (
                     <IconButton
                        sx={{ paddingRight: 2 }}
                        onClick={() => navigate('/view-cart')}
                        color='inherit'
                     >
                        <Badge badgeContent={productsCount} color='secondary'>
                           {location.pathname === '/view-cart' ? (
                              <ShoppingCartIcon />
                           ) : (
                              <ShoppingCartOutlinedIcon />
                           )}
                        </Badge>
                     </IconButton>
                  )}
                  <Hidden lgDown>
                     <Button
                        color={location.pathname === '/fittings' ? 'secondary' : 'primary'}
                        sx={location.pathname === '/fittings' ? {} : { color: 'white' }}
                        variant={location.pathname === '/fittings' ? 'contained' : 'outlined'}
                        onClick={() => navigate('/fittings')}
                     >
                        Fittings
                     </Button>
                     <Button
                        color={location.pathname === '/hoses' ? 'secondary' : 'primary'}
                        sx={location.pathname === '/hoses' ? { ml: 1 } : { color: 'white', ml: 1 }}
                        variant={location.pathname === '/hoses' ? 'contained' : 'outlined'}
                        onClick={() => navigate('/hoses')}
                     >
                        Hoses
                     </Button>
                  </Hidden>

                  {/* <Button sx={{ color: 'white', ml: 2 }} onClick={() => navigate('/app/dashboard')}>
                     <HomeIcon variant='large' />
                  </Button> */}
                  <IconButton color='inherit' onClick={onMobileNavOpen}>
                     <MenuIcon />
                  </IconButton>
               </Box>
            )}
         </Toolbar>
         {(location.pathname === '/fittings' ||
            location.pathname === '/hoses' ||
            location.pathname === '/product/' + productRoute ||
            location.pathname === '/view-cart' ||
            location.pathname === '/') && (
            <>
               {windowWidth <= 425 && (
                  <Toolbar fullWidth sx={{ flexGrow: 1 }}>
                     <Box>
                        <TextField
                           id='search'
                           fullWidth
                           size='small'
                           sx={{
                              backgroundColor: 'white',
                              justifyContent: 'center',
                              alignItems: 'center',
                              height: 40,
                              width: windowWidth * 0.9
                           }}
                           InputProps={{
                              startAdornment: (
                                 <InputAdornment position='start'>
                                    <SvgIcon fontSize='small' color='action'>
                                       <SearchIcon />
                                    </SvgIcon>
                                 </InputAdornment>
                              )
                           }}
                           placeholder={
                              location.pathname === '/fittings'
                                 ? 'Search fittings'
                                 : location.pathname === '/hoses'
                                 ? 'Search hoses'
                                 : 'Search products'
                           }
                           value={searchC}
                           onChange={e => {
                              setSearchC(e.target.value)
                           }}
                           variant='outlined'
                        />
                     </Box>
                  </Toolbar>
               )}
            </>
         )}
         {location.pathname === '/login' && windowWidth <= 425 && (
            <Toolbar fullWidth sx={{ flexGrow: 1 }} />
         )}
      </AppBar>
   )
}

export default MainNavbar
